import axios from 'axios'

export const companiesOriginalTagGroups = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    readOriginalTagGroupsSuccess(state, payload) {
      state.data = payload.data.map(v => v.attributes)
      state.loading = false
    },
    stopLoading(state) {
      state.loading = false
    },
  },
  actions: {
    readOriginalTagGroups({ commit, rootState }) {
      commit('prepareConnect')
      return axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/original/tag_groups.json')
        .then(res => {
          commit('readOriginalTagGroupsSuccess', res.data)
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
  }
}
